<template>
  <div class="vx-row bes" oncontextmenu="return false">
    <left-preview-slider v-if="isShowComment" v-on:click="isOpenPreview = $event"></left-preview-slider>
    <Transition name="baikei-transition">
    <div class="vx-col md:w-1/3 mb-base" v-if="isOpenPreview && isShowComment">
      <vx-card title="JES">
        <img src="@/assets/images/jusetsu/screen-edit/jse/jse-01.jpg" width="100%" />
      </vx-card>
    </div>
    </Transition>
    <div class="vx-col mr-7 select flex-grow-width-make" :class="[!isShowComment && !isOpenPreview ? 'w-full' : !isShowComment ? 'w-57' : 'w-65']">
      <vx-card class=" preview-edit-screen">
        <div class=" mb-3 part-parent-name">
          B売主の表示と占有に関する事項
        </div>
        <div :id="`${arrayCommentId[0]}`">
          <table class="w-full">
            <tr>
              <td colspan="12" class="part-parent-name">【売主】</td>
            </tr>
          </table>
          <table class="w-full">
            <tr>
              <table class="w-full">
                <tr>
                  <th
                    style="border-bottom: 0px; width: 276px; padding-left: 20px"
                    rowspan="6"
                    class="label-fix-length"
                  >
                    <div class="flex">
                      <span>売主種類</span>
                    </div>
                  </th>
                </tr>
                <tr>
                  <th style="border-bottom: 0">
                    <div class="flex">
                      <radio-box
                        @input="lostFocus"
                        v-model="urinushi_umusentaku"
                        vs-name="urinushi_umusentaku"
                        vs-value="0"
                      >
                        <span
                          >１．登記簿記載の所有者と同じ</span
                        >
                      </radio-box>
                      <div class="mr-8" style="padding-right: 50px"></div>
                      <radio-box
                        @input="lostFocus"
                        v-model="urinushi_umusentaku"
                        vs-name="urinushi_umusentaku"
                        style="padding-right: 10px"
                        vs-value="1"
                      >
                        <span>２．登記簿記載の所有者と異なる</span>
                      </radio-box>
                    </div>
                    <div class="text-warning" v-if="formValidation.urinushi_umusentaku.isWarning">
                      {{formValidation.urinushi_umusentaku.message_warnning}}
                    </div>
                  </th>
                </tr>
              </table>
            </tr>
            <tr>
              <table class="w-full">
                <tr>
                  <th
                    style="width: 276px; padding-left: 20px"
                    rowspan="6"
                    class="label-fix-length"
                  >
                    <div class="flex">
                      <span style="padding-right: 46px; padding-top: 10px"
                        >住所</span
                      >
                      <vs-button class="primary mr-4 btn-positive p-3" color="positive" type="filled" text-color="#7367F0" @click="copyDataJusho"
                        >売契の土地所在　反映
                      </vs-button>
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus('urinushi_jusho')" class="w-5/6" style="margin-bottom: 0;" maxlength="100" v-model="urinushi_jusho" name="urinushi_jusho"/>
                    <span class="tooltip-custom" :class="addPadding('urinushi_jusho')">{{showMaxlength(100, urinushi_jusho, 'urinushi_jusho')}}</span>
                    <div class="text-warning" v-if="formValidation.urinushi_jusho.isWarning">
                      {{formValidation.urinushi_jusho.message_warnning}}
                    </div>
                  </th>
                </tr>
              </table>
              <table class="w-full">
                <tr>
                  <th
                    style="width: 276px; padding-left: 20px; border-top: 0px"
                    rowspan="6"
                    class="label-fix-length"
                  >
                    <div class="flex">
                      <span style="padding-right: 46px; padding-top: 10px">氏名</span>
                      <vs-button class="primary mr-4 btn-positive p-3" color="positive" type="filled" text-color="#7367F0" @click="copyDataShimei">売契の売主情報　反映</vs-button>
                    </div>
                  </th>
                </tr>
                <tr>
                  <th style="border-top: 0px">
                     <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus('urinushi_shimei')" class="w-5/6" style="margin-bottom: 0;" maxlength="100" v-model="urinushi_shimei" name="urinushi_shimei"/>
                     <span class="tooltip-custom" :class="addPadding('urinushi_shimei')">{{showMaxlength(100, urinushi_shimei, 'urinushi_shimei')}}</span>
                    <div class="text-warning" v-if="formValidation.urinushi_shimei.isWarning">
                      {{formValidation.urinushi_shimei.message_warnning}}
                    </div>
                  </th>
                </tr>
              </table>
            </tr>
          </table>
          <table class="w-full">
            <tr>
              <td style="width: 276px; padding-left: 20px; border-top: 0px"
                  rowspan="6"
                  class="label-fix-length">
                <div class="flex">
                  <span class="text-center">「以下余白」の表示</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex items-center">
                  <vs-checkbox v-model="urinushi_comment_matsubi_ikayohaku_hyoji" class="inline-flex"></vs-checkbox>
                  <span class="ml-2">末尾に「以下余白」を表示する</span>
                </div>
              </td>
            </tr>
          </table>
          <table class="w-full">
            <tr>
              <td style="width: 276px; padding-left: 20px; border-top: 0px"
                  rowspan="6"
                  class="label-fix-length">
                <div class="flex">
                  <span class="text-center">黒点／ナンバリング表示</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex items-center">
                  <vs-checkbox v-model="urinushi_comment_numbering" class="inline-flex"></vs-checkbox>
                  <span class="ml-2">黒点／ナンバリングを表示する</span>
                </div>
              </td>
            </tr>
          </table>
          <draggable v-model="urinushi_comment" handle=".handle">
            <table class="w-full" v-for="(num, index) in urinushi_comment" :key="`note-${index}`" >
              <tr>
                <th
                  style="width: 276px; border-top: 0px; padding-left: 20px"
                  rowspan="6"
                  class="label-fix-length"
                >
                  <div class="flex justify-center items-center">
                    <span>売主コメント {{ index + 1 }}.</span>
                    <vs-checkbox @input="lostFocus"
                      v-model="num.checkboxDelete"
                      class="inline-flex"
                    ></vs-checkbox>
                    <div class="handle pt-3 pl-3 cursor-default w-27">
                      <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                        <DragBlackIcon />
                      </vx-tooltip>
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                <th style="border-top: 0px">
                  <div class="flex items-center mb-2">
                    <BunshoTemplate v-model="num.content" screen="M007-03-1" />
                    <span>※備考への表示状況は重要事項説明書レイアウト画面にて確認してください</span>
                  </div>
                  <vs-textarea @blur="focusOut()" @focus="onFocus(`num.content.${index}`)" v-model="num.content" rows="5" maxlength="3000"></vs-textarea>
                  <span class="tooltip-custom -mt-4" :class="addPadding(`num.content.${index}`)">{{showMaxlength(3000, num.content, `num.content.${index}`)}}</span>
                </th>
              </tr>
            </table>
          </draggable>
          <table class="w-full" >
            <tr>
              <th
                style="width: 276px; border-top: 0px; border-right: 0px"
                rowspan="6"
                class="label-fix-length"
              ></th>
            </tr>
            <tr>
              <th style="border-top: 0px; border-left: 0px">
                <div class="flex justify-end py-1">
                  <vs-button class="primary mr-4 btn-positive" @click="addTochi"
                    >項目追加
                  </vs-button>
                  <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0"
                    @click="deleteTochi('urinushi_comment')"
                    >項目削除
                  </vs-button>
                </div>
              </th>
            </tr>
          </table>
        </div>
        <br />
        <div :id="`${arrayCommentId[1]}`">
          <table class="w-full">
            <tr>
              <td colspan="12" class="part-parent-name">【売買契約締結の占有に関する事項】</td>
            </tr>
          </table>
          <table class="w-full">
            <tr>
              <table class="w-full">
                <tr>
                  <th
                    style="border-bottom: 0px; width: 276px; padding-left: 20px"
                    rowspan="6"
                    class="label-fix-length"
                  >
                    <div class="flex">
                      <span>第三者による占有</span>
                    </div>
                  </th>
                </tr>
                <tr>
                  <th style="border-bottom: 0">
                    <div class="flex">
                      <radio-box
                        @input="lostFocus"
                        v-model="daisanshasenyu_umusentaku"
                        vs-name="daisanshasenyu_umusentaku"
                        vs-value="0" @change="handleChangeDaisanshasenyuUmusentaku"
                      >
                        <span>１．有</span
                        >
                      </radio-box>
                      <div class="mr-8" style="padding-right: 50px"></div>
                      <radio-box
                        @input="lostFocus"
                        v-model="daisanshasenyu_umusentaku"
                        vs-name="daisanshasenyu_umusentaku"
                        style="padding-right: 10px"
                        vs-value="1" @change="handleChangeDaisanshasenyuUmusentaku"
                      >
                        <span>２．無</span>
                      </radio-box>
                    </div>
                    <div class="text-warning" v-if="formValidation.daisanshasenyu_umusentaku.isWarning">
                      {{formValidation.daisanshasenyu_umusentaku.message_warnning}}
                    </div>
                  </th>
                </tr>
              </table>
            </tr>
            <tr>
              <table class="w-full">
                <tr>
                  <th
                    style="width: 276px; padding-left: 20px"
                    rowspan="6"
                    class="label-fix-length"
                  >
                    <div class="flex">
                      <span style="padding-right: 46px; padding-top: 10px"
                        >住所</span
                      >
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('daisanshasenyu_jusho')" class="w-5/6" maxlength="60" v-model="daisanshasenyu_jusho" :disabled="daisanshasenyu_umusentaku != '0'" name="daisanshasenyu_jusho"/>
                    <span class="tooltip-custom" :class="addPadding('daisanshasenyu_jusho')">{{showMaxlength(60, daisanshasenyu_jusho, 'daisanshasenyu_jusho')}}</span>
                    <div class="text-warning" v-if="formValidation.daisanshasenyu_jusho.isWarning">
                      {{formValidation.daisanshasenyu_jusho.message_warnning}}
                    </div>
                  </th>
                </tr>
              </table>

              <table class="w-full">
                <tr>
                  <th
                    style="width: 276px; padding-left: 20px; border-top: 0px"
                    rowspan="6"
                    class="label-fix-length"
                  >
                    <div class="flex">
                      <span style="padding-right: 46px; padding-top: 10px"
                        >氏名</span
                      >
                    </div>
                  </th>
                </tr>
                <tr>
                  <th style="border-top: 0px">
                    <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('daisanshasenyu_shimei')" class="w-5/6" maxlength="60" name="daisanshasenyu_shimei" v-model="daisanshasenyu_shimei" :disabled="daisanshasenyu_umusentaku != '0'"/>
                    <span class="tooltip-custom" :class="addPadding('daisanshasenyu_shimei')">{{showMaxlength(60, daisanshasenyu_shimei, 'daisanshasenyu_shimei')}}</span>
                    <div class="text-warning" v-if="formValidation.daisanshasenyu_shimei.isWarning">
                      {{formValidation.daisanshasenyu_shimei.message_warnning}}
                    </div>
                  </th>
                </tr>
              </table>
            </tr>
          </table>
          <table class="w-full">
            <tr>
              <td style="width: 276px; padding-left: 20px; border-top: 0px"
                  rowspan="6"
                  class="label-fix-length">
                <div class="flex">
                  <span class="text-center">「以下余白」の表示</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex items-center">
                  <vs-checkbox v-model="senyukansuru_kenri_matsubi_ikayohaku_hyoji" :disabled="daisanshasenyu_umusentaku != '0'" class="inline-flex"></vs-checkbox>
                  <span class="ml-2">末尾に「以下余白」を表示する</span>
                </div>
              </td>
            </tr>
          </table>
          <table class="w-full">
            <tr>
              <td style="width: 276px; padding-left: 20px; border-top: 0px"
                  rowspan="6"
                  class="label-fix-length">
                <div class="flex">
                  <span class="text-center">黒点／ナンバリング表示</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex items-center">
                  <vs-checkbox v-model="senyukansuru_kenri_numbering" :disabled="daisanshasenyu_umusentaku != '0'" class="inline-flex"></vs-checkbox>
                  <span class="ml-2">黒点／ナンバリングを表示する</span>
                </div>
              </td>
            </tr>
          </table>
          <draggable v-model="senyukansuru_kenri" handle=".handle">
            <table class="w-full" v-for="(num, index) in senyukansuru_kenri" :key="`note-${index}`" >
              <tr>
                <th
                  style="width: 276px; border-top: 0px; padding-left: 20px"
                  rowspan="6"
                  class="label-fix-length"
                >
                  <div class="flex justify-center items-center">
                    <span>占有に関する権利 {{ index + 1 }}.</span>
                    <vs-checkbox @input="lostFocus"
                      v-model="num.checkboxDelete"
                      class="inline-flex"
                    ></vs-checkbox>
                    <div class="handle pt-3 pl-3 cursor-default w-27">
                      <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                        <DragBlackIcon />
                      </vx-tooltip>
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                <th style="border-top: 0px">
                  <div class="flex items-center mb-2">
                    <BunshoTemplate v-model="num.content" screen="M007-03-2" :disableButton="daisanshasenyu_umusentaku != '0'" />
                    <span>※備考への表示状況は重要事項説明書レイアウト画面にて確認してください</span>
                  </div>
                  <vs-textarea @blur="focusOut()" @focus="onFocus(`num.content2.${index}`)" v-model="num.content" rows="5" :disabled="daisanshasenyu_umusentaku != '0'" maxlength="3000"></vs-textarea>
                  <span class="tooltip-custom -mt-4" :class="addPadding(`num.content2.${index}`)">{{showMaxlength(3000, num.content, `num.content2.${index}`)}}</span>
                </th>
              </tr>
            </table>
          </draggable>
          <table class="w-full" >
            <tr>
              <th
                style="width: 276px; border-top: 0px; border-right: 0px"
                rowspan="6"
                class="label-fix-length"
              ></th>
            </tr>
            <tr>
              <th style="border-top: 0px; border-left: 0px">
                <div class="flex justify-end py-1">
                  <vs-button class="primary mr-4 btn-positive" @click="addToBox"
                    >項目追加
                  </vs-button>
                  <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0"
                    @click="deleteTochi('senyukansuru_kenri')"
                    >項目削除
                  </vs-button>
                </div>
              </th>
            </tr>
          </table>
        </div>
      </vx-card>
      <footer-button @cancel="popupActiveCancelForm = true" @save="checkSave"></footer-button>
      <!-- Popup Delete Tochi -->
      <vs-popup
        class="holamundo"
        title="解除"
        :active.sync="popupActiveDeleteTochi"
        :button-close-hidden="true"
      >
        <p class="my-4 font-bold text-lg">
          選択された項目を削除します。よろしいですか？
        </p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-positive btn-yes" @click="handleDeleteTochi"
            >はい</vs-button
          >
          <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0"
            @click="popupActiveDeleteTochi = false"
            >いいえ</vs-button
          >
        </div>
      </vs-popup>
      <vs-popup
        class="holamundo"
        title="キャンセル"
        :active.sync="popupActiveCancelForm"
        :button-close-hidden="true"
      >
        <p class="my-4 font-bold text-lg">
          入力内容を破棄して元の画面へ移動します。よろしいですか？
        </p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-positive btn-yes" @click="handleCancelForm"
            >はい</vs-button
          >
          <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActiveCancelForm = false"
            >いいえ</vs-button
          >
        </div>
      </vs-popup>
      <!-- Popup Save -->
      <vs-popup
        class="holamundo"
        title="保存"
        :active.sync="popupActiveSaveForm"
        :button-close-hidden="true"
      >
        <p class="my-4 font-bold text-lg">
          {{messageWhenHanei}}
        </p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-positive btn-yes" @click="handleSaveForm"
            >はい</vs-button
          >
          <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActiveSaveForm = false"
            >いいえ</vs-button
          >
        </div>
      </vs-popup>
    </div>
    <vx-card class="vx-col comment-frame" id="closeCommentSiderPattern" :class="isShowComment ? 'closeComment': 'showComment'">
      <Comment @showHightlightInPage="handleShowHightlightInPage" @commentData="getArrayHighlight" :pattern="jsePattern" :screenCode="screenCode='M007-03'"/>
    </vx-card>
  </div>
</template>
<script>

import _ from 'lodash'
import BunshoTemplate from './components/BunshoTemplate.vue'
import FooterButton from './components/FooterButton.vue'
import RadioBox from './components/RadioBox.vue'
import { SAVE_JSE, SAVE_EDIT_MODE, SAVE_KEIYAKU } from '@/store/modules/keiyaku/actions'
import { MESSAGE } from '../constant/message_code'
import routeIfCodeNull from '@/mixins/routeIfCodeNull'
import LeftPreviewSlider from './components/LeftPreviewSlider.vue'
import utilitiesMethods from '@/mixins/utilitiesMethods'
import Comment from './comment'
import { jseHighlight } from '../constant/highlight'
import highlighter from '../mixins/highlighter'
import DragBlackIcon from '@/assets/images/icons/DragBlackIcon.vue'
import draggable from 'vuedraggable'

export default {
  mixins: [routeIfCodeNull, utilitiesMethods, highlighter],
  components: {
    BunshoTemplate,
    FooterButton,
    RadioBox,
    LeftPreviewSlider,
    DragBlackIcon,
    draggable,
    Comment
  },
  data() {
    return {
      arrayCommentId: [],
      arrayHighlightId: [],
      isShowComment: true,
      isOpenPreview: true,
      messageWhenHanei: MESSAGE.M1007,
      
      urinushi_umusentaku: null,
      urinushi_jusho: '',
      urinushi_shimei: '',
      daisanshasenyu_umusentaku: null,
      daisanshasenyu_jusho: '',
      daisanshasenyu_shimei: '',
      date: null,
      bikouType: '',
      popupActiveDeleteTochi: false,
      popupActiveCancelForm: false,
      popupActiveSaveForm: false,
      // urinushi_comment array<string>
      urinushi_comment: [
        {
          checkboxDelete: false,
          content: ''
        }
      ],
      // senyukansuru_kenri array<string>
      senyukansuru_kenri: [
        {
          checkboxDelete: false,
          content: ''
        }
      ],
      checkValidate: false,
      formValidation: {
        urinushi_umusentaku: {
          message_warnning: MESSAGE.E8051,
          warning: true,
          isWarning: false
        },
        urinushi_jusho: {
          message_warnning: MESSAGE.E8051,
          warning: true,
          isWarning: false
        },
        urinushi_shimei: {
          message_warnning: MESSAGE.E8051,
          warning: true,
          isWarning: false
        },
        daisanshasenyu_umusentaku: {
          message_warnning: MESSAGE.E8051,
          warning: true,
          isWarning: false
        },
        daisanshasenyu_jusho: {
          message_warnning: MESSAGE.E8051,
          warning:() => {
            return this.daisanshasenyu_umusentaku !== null && +this.daisanshasenyu_umusentaku === 0 && (
              this.daisanshasenyu_jusho === null || this.daisanshasenyu_jusho === '')
          },
          isWarning: false
        },
        daisanshasenyu_shimei: {
          message_warnning: MESSAGE.E8051,
          warning: () => {
            return this.daisanshasenyu_umusentaku !== null && +this.daisanshasenyu_umusentaku === 0 && (
              this.daisanshasenyu_shimei === null || this.daisanshasenyu_shimei === '')
          },
          isWarning: false
        },
        urinushi_comment: {
          warning: () => {

          }
        },
        senyukansuru_kenri: {
          warning: () => {

          }
        }
      },
      hasWarning: false,
      urinushi_comment_numbering: true,
      urinushi_comment_matsubi_ikayohaku_hyoji: true,
      senyukansuru_kenri_matsubi_ikayohaku_hyoji: false,
      senyukansuru_kenri_numbering: false
    }
  },
  computed: {
    getStateShowComment() {
      return this.$store.getters.getStateShowComment
    },
    getLeftPreviewSliderStatus() {
      return this.$store.getters.getLeftPreviewSliderStatus
    },
    jsePattern() {
      return _.get(this.$store.getters.pattern, 'jusetsu.jse', null)
    },
    jusetsuJseData() {
      return _.cloneDeep(_.get(this.$store.getters.keiyaku, 'jusetsu.jse', null))
    },
    bscData() {
      return _.cloneDeep(_.get(this.$store.getters.keiyaku, 'baikei.bsc', null))
    }
  },
  mounted() {
    this.getStyleForEditScreen()
    this.handleGetCommentId()
    this.isShowComment = this.getStateShowComment
    this.isOpenPreview = this.getLeftPreviewSliderStatus
    if (this.jusetsuJseData !== null) {
      const jusetsuJseData = this.jusetsuJseData
      this.urinushi_comment_numbering = jusetsuJseData.urinushi_comment_numbering === undefined ? true : jusetsuJseData.urinushi_comment_numbering
      this.urinushi_comment_matsubi_ikayohaku_hyoji = jusetsuJseData.urinushi_comment_matsubi_ikayohaku_hyoji === undefined ? true : jusetsuJseData.urinushi_comment_matsubi_ikayohaku_hyoji
      this.senyukansuru_kenri_matsubi_ikayohaku_hyoji = jusetsuJseData.senyukansuru_kenri_matsubi_ikayohaku_hyoji
      this.senyukansuru_kenri_numbering = jusetsuJseData.senyukansuru_kenri_numbering
      this.urinushi_umusentaku = jusetsuJseData.urinushi_umusentaku
      this.urinushi_jusho = jusetsuJseData.urinushi_jusho
      this.urinushi_shimei = jusetsuJseData.urinushi_shimei
      if (Array.isArray(jusetsuJseData.urinushi_comment)) {
        this.urinushi_comment = jusetsuJseData.urinushi_comment.map(item => {
          return {
            checkboxDelete: false,
            content: item
          }
        })
      }
      this.daisanshasenyu_umusentaku = jusetsuJseData.daisanshasenyu_umusentaku
      this.daisanshasenyu_jusho = jusetsuJseData.daisanshasenyu_jusho
      this.daisanshasenyu_shimei = jusetsuJseData.daisanshasenyu_shimei
      if (Array.isArray(jusetsuJseData.senyukansuru_kenri)) {
        this.senyukansuru_kenri = jusetsuJseData.senyukansuru_kenri.map(item => {
          return {
            checkboxDelete: false,
            content: item
          }
        })
      }
    }

    const editMode = _.get(this.$store.getters.editMode, 'jse', false)
    if (editMode) {
      this.validateWarning()
    }
  },
  watch: {
    '$store.getters.getStateShowComment' (val) {
      this.isShowComment = val
    },
    '$store.getters.getLeftPreviewSliderStatus' (val) {
      this.isOpenPreview = val
    }
  },
  methods: {
    addTochi() {
      this.urinushi_comment.push({
        checkboxDelete: false,
        content: ''
      })
    },
    addToBox() {
      this.senyukansuru_kenri.push({
        checkboxDelete: false,
        content: ''
      })
    },
    copyDataJusho() {
      if(this.bscData !== null) {
        this.urinushi_jusho = this.bscData.urinushishomei[0].jusho
      }
    },
    copyDataShimei() {
      this.urinushi_shimei = this.bscData.urinushishomei[0].shimei
    },
    handleCheckboxTochi(type, event, index) {
      if(type === 'urinushi') {
        this.urinushi_comment[index].checkboxDelete = event.target.checked
      }
      if(type === 'senyukansuru') {
        this.senyukansuru_kenri[index].checkboxDelete = event.target.checked
      }
    },
    handleDeleteTochi() {
      const initData = [
        {
          checkboxDelete: false,
          content: ''
        }
      ]
      switch(this.bikouType) {
      case 'urinushi_comment':
        this.urinushi_comment =
        this.urinushi_comment.length === this.urinushi_comment.filter((v) => v.checkboxDelete === true).length ? initData : this.urinushi_comment.filter((v) => v.checkboxDelete === false)
        break
      case 'senyukansuru_kenri':
        this.senyukansuru_kenri =
        this.senyukansuru_kenri.length === this.senyukansuru_kenri.filter((v) => v.checkboxDelete === true).length ? initData : this.senyukansuru_kenri.filter((v) => v.checkboxDelete === false)
        break
      }
      this.bikouType = ''
      this.popupActiveDeleteTochi = false
    },
    handleCancelForm() {
      this.handleSaveCountLocal()
      this.popupActiveCancelForm = false
      setTimeout(() => {
        this.$router.push({name: 'jusetsu-m006-01'})
      }, 100)
    },
    deleteTochi(type) {
      switch (type) {
      case 'urinushi_comment':
        if (!this.urinushi_comment.filter(urinushi => urinushi.checkboxDelete === true).length) {
          this.$toasted.error('項目が選択されていません。')
          return
        }
        this.bikouType = 'urinushi_comment'
        this.popupActiveDeleteTochi = true
        break
      case 'senyukansuru_kenri':
        if (!this.senyukansuru_kenri.filter(senyukansuru => senyukansuru.checkboxDelete === true).length) {
          this.$toasted.error('項目が選択されていません。')
          return
        }
        this.bikouType = 'senyukansuru_kenri'
        this.popupActiveDeleteTochi = true
        break
      }
    },
    handleChangeDaisanshasenyuUmusentaku() {
      if(String(this.daisanshasenyu_umusentaku) !== '0') {
        this.daisanshasenyu_jusho = ''
        this.daisanshasenyu_shimei = ''
        this.senyukansuru_kenri = [
          {
            checkboxDelete: false,
            content: ''
          }
        ]
      }
      this.senyukansuru_kenri_matsubi_ikayohaku_hyoji = (this.daisanshasenyu_umusentaku === '0')
      this.senyukansuru_kenri_numbering = (this.daisanshasenyu_umusentaku === '0')
    },
    handleSaveForm() {
      const handle = () => {
        const data = {
          senyukansuru_kenri_matsubi_ikayohaku_hyoji: this.senyukansuru_kenri_matsubi_ikayohaku_hyoji,
          urinushi_comment_numbering: this.urinushi_comment_numbering,
          urinushi_comment_matsubi_ikayohaku_hyoji: this.urinushi_comment_matsubi_ikayohaku_hyoji,
          senyukansuru_kenri_numbering: this.senyukansuru_kenri_numbering,
          urinushi_umusentaku: this.urinushi_umusentaku,
          urinushi_jusho: this.urinushi_jusho,
          urinushi_shimei: this.urinushi_shimei,
          urinushi_comment: this.urinushi_comment.map(v => v.content),
          daisanshasenyu_umusentaku: this.daisanshasenyu_umusentaku,
          daisanshasenyu_jusho: this.daisanshasenyu_jusho,
          daisanshasenyu_shimei: this.daisanshasenyu_shimei,
          senyukansuru_kenri: this.senyukansuru_kenri.map(v => v.content)
        }
        this.$store.dispatch(SAVE_JSE, data).then(() => {
          this.$store.dispatch(SAVE_EDIT_MODE, {'jse': true})
          this.$store.dispatch(SAVE_KEIYAKU).then(() => {
            this.popupActiveSaveForm = false
            setTimeout(() => {
              this.$router.push({name: 'jusetsu-m006-01'})
            }, 200)
          })
        })
      }
      this.handleCheckCount(handle)
      this.popupActiveSaveForm = false
    },
    highlight(key, isHighlight = true, eleIndex = null) {
      if (eleIndex === null) {
        // selectbox
        if (isHighlight) {
          $(`.v-select[name='${key}']`).find('.vs__dropdown-toggle').css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          $(`.v-select[name='${key}']`).find('.vs__dropdown-toggle').css({'background-color': 'inherit'})
        }
        // radiobox
        $('.con-vs-radio').each((idx, el) => {
          if ($(el).find(`input[name='${key}']`).length) {
            if (isHighlight) {
              $(el).find('span.vs-radio--borde').css({'border-color': '#eea840'})
            } else {
              $(el).find('span.vs-radio--borde').css({'border-color': '#c8c8c8'})
            }
          }
        })
        // checkbox
        $('.con-vs-checkbox').each((idx, el) => {
          if ($(el).find(`input[vs-name='${key}']`).length) {
            if (isHighlight) {
              $(el).find('span.vs-checkbox').css({'border-color': '#eea840'})
            } else {
              $(el).find('span.vs-checkbox').css({'border-color': '#c8c8c8'})
            }
          } else if ($(el).find(`input[name='${key}']`).length) {
            if (isHighlight) {
              $(el).find('span.vs-checkbox').css({'border-color': '#eea840'})
            } else {
              $(el).find('span.vs-checkbox').css({'border-color': '#c8c8c8'})
            }
          }
        })
        // vs-input
        const inputEl = $(`input[name='${key}']`)
        if (isHighlight) {
          inputEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          inputEl.css({'background-color': 'inherit'})
        }
        // vs-textarea
        const textareaEl = $(`textarea[name='${key}']`)
        if (isHighlight) {
          textareaEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          textareaEl.css({'background-color': 'inherit'})
        }
        // datepicker
        const selectEl = $(`div[datepicker='${key}']`).find('.vs__dropdown-toggle')
        const yearEl = $(`div[datepicker='${key}']`).find('input[name="year"]')
        const monthEl = $(`div[datepicker='${key}']`).find('input[name="month"]')
        const dayEl = $(`div[datepicker='${key}']`).find('input[name="day"]')
        if (isHighlight) {
          selectEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          yearEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          monthEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          dayEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          selectEl.css({'background-color': 'inherit'})
          yearEl.css({'background-color': 'inherit'})
          monthEl.css({'background-color': 'inherit'})
          dayEl.css({'background-color': 'inherit'})
        }
      } else {
        // selectbox
        const selectboxEl = $(`.v-select[name='${key}']`)
        if (selectboxEl.length) {
          if (isHighlight) {
            $(selectboxEl[eleIndex]).find('.vs__dropdown-toggle').css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            $(selectboxEl[eleIndex]).find('.vs__dropdown-toggle').css({'background-color': 'inherit'})
          }
        }
        // radiobox
        $('.con-vs-radio').each((idx, el) => {
          const radioEl = $(el).find(`input[name='${key}']`)
          if (radioEl.length && $(radioEl[eleIndex]).length) {
            if (isHighlight) {
              $(radioEl[eleIndex]).find('span.vs-radio--borde').css({'border-color': '#eea840'})
            } else {
              $(radioEl[eleIndex]).find('span.vs-radio--borde').css({'border-color': '#c8c8c8'})
            }
          }
        })
        // vs-input
        const inputEl = $(`input[name='${key}']`)
        if (inputEl.length) {
          if (isHighlight) {
            $(inputEl[eleIndex]).css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            $(inputEl[eleIndex]).css({'background-color': 'inherit'})
          }
        }
        // vs-textarea
        const textareaEl = $(`textarea[name='${key}']`)
        if (textareaEl.length) {
          if (isHighlight) {
            $(textareaEl[eleIndex]).css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            $(textareaEl[eleIndex]).css({'background-color': 'inherit'})
          }
        }

        // datepicker
        if ($(`div[datepicker='${key}']`).length) {
          const selectEl = $(`div[datepicker='${key}']`)[eleIndex].find('.vs__dropdown-toggle')
          const yearEl = $(`div[datepicker='${key}']`)[eleIndex].find('input[name="year"]')
          const monthEl = $(`div[datepicker='${key}']`)[eleIndex].find('input[name="month"]')
          const dayEl = $(`div[datepicker='${key}']`)[eleIndex].find('input[name="day"]')
          if (isHighlight) {
            selectEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
            yearEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
            monthEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
            dayEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            selectEl.css({'background-color': 'inherit'})
            yearEl.css({'background-color': 'inherit'})
            monthEl.css({'background-color': 'inherit'})
            dayEl.css({'background-color': 'inherit'})
          }
        }
      }
    },
    validateWarning() {
      const context = this
      this.hasWarning = false
      Object.keys(this.formValidation).forEach(key => {
        this.formValidation[key].isWarning = false
        if (!this.formValidation[key].patterns || !this.formValidation[key].patterns.length
          || this.formValidation[key].patterns.includes(this.jsePattern)) {
          // ARRAY
          if (this.formValidation[key].elements) {
            this.formValidation[key].elements.forEach((child, idx) => {
              Object.keys(child).forEach(childKey => {
                if (typeof (context.formValidation[key].elements[idx][childKey].warning) === 'function' && this.formValidation[key].elements[idx][childKey].warning(idx)) {
                  context.formValidation[key].elements[idx][childKey].isWarning = true
                  context.highlight(childKey, true, idx)
                  context.hasWarning = true
                  context.messageWhenHanei = MESSAGE.M1017
                } else if (typeof (context.formValidation[key].elements[idx][childKey].warning) !== 'function'
                  && (context[key][idx][childKey] === null || context[key][idx][childKey] === undefined
                  || context[key][idx][childKey] === '' || context[key][idx][childKey] === false
                  || context[key][idx][childKey] === '　')) {
                  context.formValidation[key].elements[idx][childKey].isWarning = true
                  context.highlight(childKey, true, idx)
                  context.hasWarning = true
                  context.messageWhenHanei = MESSAGE.M1017
                } else {
                  context.formValidation[key].elements[idx][childKey].isWarning = false
                  context.highlight(childKey, false, idx)
                }
              })
            })
          } else if (typeof (this.formValidation[key].warning) === 'function' && this.formValidation[key].warning()) {
            this.formValidation[key].isWarning = true
            this.hasWarning = true
            this.highlight(key)
            this.messageWhenHanei = MESSAGE.M1017
          } else if (typeof (this.formValidation[key].warning) !== 'function' && this.formValidation[key].warning
            && (this[key] === null || this[key] === undefined || this[key] === '' || this[key] === false || this[key] === '　')) {
            this.formValidation[key].isWarning = true
            this.highlight(key)
            this.hasWarning = true
            this.messageWhenHanei = MESSAGE.M1017
          } else {
            this.highlight(key, false)
          }
        }
      })
      this.checkValidate = true
      return this.hasWarning
    },
    validateError() {
      const hasError = false
      // TODO
      return hasError
    },
    async checkSave() {
      const hasWarning = await this.validateWarning()
      if (hasWarning) {
        this.messageWhenHanei = MESSAGE.M1017
        this.popupActiveSaveForm = true
        return
      }else{
        this.messageWhenHanei = MESSAGE.M1007
      }
      this.popupActiveSaveForm = true
    },
    lostFocus() {
      if (this.checkValidate === true) {
        setTimeout(() => {
          this.validateWarning()
        }, 20)
      }
    },
    focusOut() {
      this.currentFocus = 0
      this.lostFocus()
    },
    getArrayHighlight(data) {
      const idElement = []
      const block_list = data.block_list
      block_list.forEach(item => {
        item.part_list.map(ele => {
          if(!ele.label_flg) {
            idElement.push(ele.id_element)
          }
        })
      })
      this.arrayHighlightId = idElement.filter(item => item.includes('jse'))
    },
    handleGetCommentId() {
      let jsePatternPatternHighlight = []
      switch (this.jtmPattern) {
      case 'jrb-01':
        jsePatternPatternHighlight = jseHighlight
        break
      default:
        break
      }
      jsePatternPatternHighlight = jseHighlight
      let index = 0
      const jsePatternHighlight = jsePatternPatternHighlight.map(item => {
        if(item) {
          index = index + 1
          item = `${this.jsePattern}-${index}`
        }
        return item
      })
      this.arrayCommentId = jsePatternHighlight
    },
    handleShowHightlightInPage(highlight) {
      const idHightlighted = this.arrayHighlightId
      this.handleShowHightlightInPageMixin(highlight, idHightlighted)
    }
  }
}
</script>
<style lang="scss" scoped>
.color-message-warnning {
    color: orange;
}

.bes {
  font-weight: bold;
}
table {
  border-collapse: collapse;
}
td,
th {
  border: 1px solid #b8c2cc;
  padding: 0.5rem;
}
.label-fix-length {
  width: 120px;
}
.label-fix-half-length {
  width: 60px;
}
.label-fix-bigger-length {
  width: 290px;
}
.custom-select {
  background: none;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
  cursor: text;
  font-weight: bold;
  color: #626262;
}
.btn-positive {
  border: 1px solid #7367F0;
}
.baikei-transition-enter-active {
  transition: all 0.25s ease-out;
}

.baikei-transition-leave-active {
  transition: all 0.25s ease-in;
}

.baikei-transition-enter,
.baikei-transition-leave-to {
  transform: translateX(-50px);
  opacity: 0;
  width: 0% !important;
}
.flex-grow-width-make {
  flex-grow: 1;
  flex-basis: 57%;
  min-width: 57%;
}
.preview-edit-screen {
  overflow: scroll;
  height: 615px;
  margin-top: 0.75rem;
}
.comment-frame {
  overflow: scroll;
  height: 615px;
  margin-top: 0.75rem;

}
.w-57 {
  width: 57%;
}
.w-65 {
  width: 65%;
}
.showComment {
  width: 42%;
  visibility: visible;
  opacity: 1;
  transition-delay: 0s;
}
.closeComment {
  width: 0%;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s linear 500ms, opacity 500ms;
}
</style>
